import { App } from 'vue';
import { capitalize, capitalizeAll } from '@/helpers/string';

// eslint-disable-next-line
export default function(app: App) {
    app.config.globalProperties.$filters = {
        capitalize: (word: string) => capitalize(word),
        capitalizeAll: (word: string) => capitalizeAll(word),
    };
}
